<div class="container mt-4">
  <app-confirm-dialog
    [isOpen]="isConfirmDialogOpen"
    [title]="'Kali ERP: Confirmacao'"
    [message]="'Deseja realmente excluir esta conta a pagar?'"
    [cancelLabel]="'Nao'"
    [confirmLabel]="'Sim, excluir'"
    (cancelled)="fecharDialogExcluirConta()"
    (confirmed)="confirmarExclusaoConta()">
  </app-confirm-dialog>

  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Contas a Pagar</h1>
    <button class="btn btn-primary" (click)="novaConta()">Incluir Nova Conta</button>
  </div>
  <hr />

  <div class="vencer-card" [class.vencer-card--alerta]="(resumoAVencer?.quantidade ?? 0) > 0">
    <div class="vencer-card__info">
      <span class="vencer-card__eyebrow">Próximos {{ diasAVencer }} dias</span>

      <ng-container *ngIf="isCarregandoResumo">
        <p class="vencer-card__valor">Carregando...</p>
      </ng-container>

      <ng-container *ngIf="!isCarregandoResumo && hasErroResumo">
        <p class="vencer-card__valor vencer-card__valor--erro">Não foi possível carregar</p>
        <p class="vencer-card__detalhe">Tente novamente em instantes.</p>
      </ng-container>

      <ng-container *ngIf="!isCarregandoResumo && !hasErroResumo && resumoAVencer">
        <p class="vencer-card__valor">
          {{ resumoAVencer.quantidade }}
          {{ resumoAVencer.quantidade === 1 ? 'conta a vencer' : 'contas a vencer' }}
        </p>
        <p class="vencer-card__detalhe">
          <ng-container *ngIf="resumoAVencer.quantidade > 0">
            Total de {{ resumoAVencer.valorTotal | currency:'BRL' }} entre
            {{ resumoAVencer.dataInicial | date:'dd/MM/yyyy' }} e
            {{ resumoAVencer.dataFinal | date:'dd/MM/yyyy' }}.
          </ng-container>
          <ng-container *ngIf="resumoAVencer.quantidade === 0">
            Nenhum vencimento em aberto até {{ resumoAVencer.dataFinal | date:'dd/MM/yyyy' }}.
          </ng-container>
        </p>
      </ng-container>
    </div>

    <button type="button" class="btn btn-outline-secondary btn-sm"
      (click)="loadResumoAVencer()" [disabled]="isCarregandoResumo">
      Atualizar
    </button>
  </div>

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por fornecedor, destino ou subgrupo" [(ngModel)]="searchTerm">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
      <button class="btn btn-outline-secondary" type="button" (click)="searchTerm = ''; loadContas()">Limpar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Fornecedor</th>
          <th scope="col">Destino</th>
          <th scope="col">Valor</th>
          <th scope="col">Vencimento</th>
          <th scope="col">Status</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let conta of filteredContas">
          <td>{{ conta.fornecedor }}</td>
          <td class="text-truncate" style="max-width: 150px;" [title]="conta.destino">
            {{ conta.destino }}
            <span *ngIf="conta.totalParcelas" class="badge bg-light text-dark border ms-1"
              title="Parcela de um lançamento parcelado">
              {{ conta.numParcela }}/{{ conta.totalParcelas }}
            </span>
          </td>
          
          <td>{{ conta.valor | currency:'BRL' }}</td>
          <td>{{ conta.dataVencimento | date:'dd/MM/yyyy' }}</td>
          <td>
            <span class="badge"
              [class.bg-success]="conta.status === 'CONCLUIDO'"
              [class.bg-warning]="conta.status === 'AGUARDANDO'"
              [class.text-dark]="conta.status === 'AGUARDANDO'"
              [class.bg-secondary]="conta.status !== 'CONCLUIDO' && conta.status !== 'AGUARDANDO'">
              {{ conta.status }}
            </span>
          </td>
      @if (conta.status === 'CONCLUIDO'){
          <td class="text-center">
            <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="editarConta(conta.id)">Visualizar</button>
         </td>
      } @else {
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarConta(conta.id)">Editar</button>
            <button type="button" class="btn btn-danger btn-sm  me-2" (click)="deleteConta(conta.id)">Excluir</button>
            <button type="button" class="btn btn-success btn-sm  me-2" (click)="pagarConta(conta.id, conta.valor)">Pagar</button>
          </td>
      }
        </tr>
        <tr *ngIf="filteredContas.length === 0">
          <td colspan="6" class="text-center text-muted py-4">Nenhuma conta a pagar encontrada.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
      </li>
    </ul>
  </nav>

  <!-- Modal de Confirmação de Pagamento -->
  <div *ngIf="showPagarModal" class="modal-backdrop"></div>
  <div *ngIf="showPagarModal" class="modal" tabindex="-1" style="display: block;">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar Pagamento</h5>
          <button type="button" class="btn-close" (click)="closePagarModal()"></button>
        </div>
        <div class="form modal-body">
          
          <p>Você irá dar baixa nesta conta. Por favor, confirme os dados do pagamento. 
            Não será possível reverter esta operação.</p>

          <div class="mb-3">
            <label for="valor" class="form-label">Valor pago</label>
            <input type="number" id="valor" class="form-control" [(ngModel)]="selectedValor">
          </div>

          <div class="mb-3">
            <label for="dataPagamento" class="form-label">Data do pagamento</label>
            <input type="date" id="dataPagamento" class="form-control" [(ngModel)]="selectedDataPagamento">
          </div>

          <div class="mb-3">
            <label for="parametros" class="form-label">Forma de retirada</label>
            <select id="parametros" class="form-control" [(ngModel)]="selectedFormaRetirada" name="parametros" required>
              <option *ngFor="let p of parametros" [value]="p.descricao">{{ p.descricao }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label for="observacao" class="form-label">Observação</label>
            <textarea id="observacao" class="form-control" rows="3" [(ngModel)]="selectedObservacao" placeholder="Informações adicionais sobre o pagamento"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" (click)="confirmarPagamento()" >Confirmar</button>
          <button type="button" class="btn btn-secondary" (click)="closePagarModal()">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</div>
